import { render } from "./GameTask.vue?vue&type=template&id=84c263ae&bindings={\"title\":\"setup\",\"content\":\"setup\",\"code\":\"setup\",\"letter\":\"setup\",\"task_id\":\"setup\",\"playSound\":\"setup\"}"
import script from "./GameTask.vue?vue&type=script&lang=js"
export * from "./GameTask.vue?vue&type=script&lang=js"

import "./GameTask.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script